module.exports = __webpack_public_path__ + "img/menu_share.762c7e73.png";